import { BoxProps } from '@chakra-ui/react';
import React from 'react';
import { LinkProps as RouterLinkProps } from 'react-router-dom';

import { CmFlex, CmLink } from '@/components/uiParts';

import { ChevronRightIcon } from '../Icon';

type LinkProps = BoxProps & RouterLinkProps;
interface Props extends LinkProps {
  to: string;
}

export const CmNextLink = ({ children, to, width }: Props): JSX.Element => {
  return (
    <CmFlex {...{ width }} alignItems="center">
      <CmLink width="max-content" color="blue.500" {...{ to }}>
        {children}
        <ChevronRightIcon mt="-2px" height="6" width="6" color="blue.500" />
      </CmLink>
    </CmFlex>
  );
};
